import { GenericStencil } from "@brexhq/metal-generic-stencil";
import React from "react";

import { Container } from "../../../layout/Container/Container";
export const MobileMenuLoadingStencil = () => (
  <Container
    gap="xsml"
    direction="column"
    padding={"xsml"}
    height={"max-content"}
  >
    <GenericStencil width={"100%"} height={30} />
    <GenericStencil width={"100%"} height={30} />
    <GenericStencil width={"100%"} height={30} />
    <GenericStencil width={"100%"} height={30} />
  </Container>
);

export const MobileBottomCtasStencil = () => (
  <Container gap="xsml" direction="row" padding={"xsml"}>
    <GenericStencil width={100} height={30} />
    <GenericStencil width={100} height={30} />
  </Container>
);

export const MobileCTALoadingStencil = () => (
  <div>
    <GenericStencil width={100} height={30} />
  </div>
);
